import { useSrpContext } from '@/src/contexts'
import { getFlightLogo } from '@/src/utils/confirmation/airlineUtils'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import PolicyComparison from './policyComparison'

const POLICY_KEYS = [
    'checkedBaggage',
    'cabinBaggage',
    'meals',
    'wifi',
    'entertainment',
    'checkinPolicy',
    'directFlights',
    'seatSelection',
    'cabinClasses'
] as const

const PolicyComparisonWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const policyTable = sections?.airlines?.policyTable
    if (!policyTable?.length) return null

    const policyRows = POLICY_KEYS.map(key => ({ key, label: t(key) }))

    const airlines = useMemo(
        () =>
            policyTable.map(airline => ({
                airlineCode: airline.airlineCode,
                airlineName: airline.airlineName,
                logoUrl: getFlightLogo(airline.airlineCode),
                values: {
                    checkedBaggage: airline.checkedBaggage,
                    cabinBaggage: airline.cabinBaggage,
                    meals: airline.meals,
                    wifi: airline.wifi,
                    entertainment: airline.entertainment,
                    checkinPolicy: airline.checkinPolicy,
                    directFlights: airline.directFlights,
                    seatSelection: airline.seatSelection,
                    cabinClasses: airline.cabinClasses?.join(', ') ?? ''
                }
            })),
        [policyTable]
    )

    return <PolicyComparison title={t('airlineComparisonTable')} airlines={airlines} policyRows={policyRows} />
}

export default PolicyComparisonWrapper
